import styled from "styled-components";

export const Container = styled.div`
  max-width: 1300px;
  margin: 0 auto;
`;

export const SectionHeader = styled.div`
  text-align: center;
  max-width: 700px;
  margin: 0 auto 80px;
`;

export const Subtitle = styled.div`
  font-size: 12px;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #c9a86c;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const Title = styled.h2`
  font-size: 44px;
  font-weight: 300;
  color: #1a1a1a;
  margin-bottom: 28px;
  line-height: 1.2;

  strong {
    font-weight: 600;
  }

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const Description = styled.p`
  font-size: 17px;
  color: #666;
  line-height: 1.9;
  font-weight: 300;
`;
